var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section main-attorneys"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg tit--point line-height-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.lang === "ko" ? "구성원" : "Attorneys"))]), _c('span', {
    staticClass: "ko tit--point__circle border-grey",
    attrs: {
      "data-aos": "zoom-in"
    }
  })])]), _c('lawyer-cards', {
    staticClass: "row--xl main-lawyer-cards",
    attrs: {
      "mouseOver": "",
      "lang": _vm.lang
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }